import main from './main.js'
import apiMenu from '@/api/Menu.js'
import apiOutlet from '@/api/Outlet.js'
import apiCustomer from '@/api/Customer.js'
import apiCart from '@/api/Cart.js'
import apiOrder from '@/api/Order.js'
import apiTenant from '@/api/Tenant.js'
import apiPayment from '@/api/Payment.js'
import apiCampaign from '@/api/Campaign.js'
import apiCoupon from '@/api/Coupon.js'
import apiSlotGame from '@/api/SlotGame.js'
import apiBanners from '@/api/Banners.js'
import apiContent from '@/api/Content.js'
import apiTopic from '@/api/Topic.js'
import apiLoyalty from '@/api/Loyalty.js'
import apiGiftcard from '@/api/Giftcard.js'
import _ from 'lodash'

const ModalNotify = () => import('./components/popup/ModalNotify')

var axios = require('axios')
axios.options = {
  flag: false, // false : not show ajax loader
  notify: false // false : not show notify error
}
axios.defaults.baseURL = process.env.host
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.interceptors.request.use(
  success => {
    if (success.url && (success.url.indexOf(main.$const.ACTION_LOGIN) > -1 || success.url.indexOf(main.$const.ACTION_REGISTER) > -1)) {
      try {
        const telemetry = main.getTelemetryHeader()
        if (telemetry !== null) {
          success.headers['BM-Telemetry'] = telemetry
        }
      } catch (error) {
        console.log('bmark-error', error)
      }
    }

    if (axios.options.flag) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, true)
    }

    return success
  },
  error => {
    if (axios.options.flag) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, false)
    }

    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  success => {
    if (axios.options.flag) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, false)
    }

    axios.options.flag = true
    axios.options.notify = true

    return success
  },
  error => {
    if (axios.options.flag) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, false)
    }

    axios.options.flag = true
    if (error.response.data && error.response.data.error) {
      if (error.response.data.error.code == main.$const.CUSTOMER_CODE.INVALID) {
        main.$auth.logout()
      } else if (error.response.data.error.code == main.$const.COUPON_CODE.TOKEN_INVALID) {
        main.$auth.logout()
      }

      // convert message
      let message = main.getMessageFromGms(error.response.data)
      let _code = error.response.data.error.code
      if (message) {
        error.response.data.error.message = message
      }
      // PAYMENT COUPON ERROR
      if (main.$const.PAYMENT_COUPON_ERROR.indexOf(_code) >= 0) {
        let _error = error.response.data.error
        if (
          _error.hasOwnProperty('data') && !main.empty(_error.data)
        ) {
          let _paymentList = _error.data || []
          let paymentName = []
          if (!main.empty(_paymentList)) {
            for (let p of _paymentList) {
              paymentName = paymentName.concat(p.payment_list.split(', '))
            }
            message = main.$t('coupon.payment_custom', {name: _.uniq(paymentName).join(', ')})
            error.response.data.error.message = message
          }
        }
      }
      if ([main.$const.CART_CODE.SELLINGTIME, main.$const.CART_CODE.INVALIDHUTDAY, main.$const.CART_CODE.INVALIDLUNCHTIME, main.$const.CART_CODE.NOTFOUND, main.$const.CART_CODE.INVALID_PURCHASE_SPECIFIED_TIME].indexOf(error.response.data.error.code) < 0) {
        if (axios.options.notify && main.$const.NON_NOTIFY.indexOf(main.$route.name) < 0) {
          main.$notify({
            type: 'error',
            title: message
          })
        }
      }
      axios.options.notify = true
    }

    return Promise.reject(error)
  }
)

axios.apiMenu = apiMenu
axios.apiOutlet = apiOutlet
axios.apiCustomer = apiCustomer
axios.apiCart = apiCart
axios.apiOrder = apiOrder
axios.apiTenant = apiTenant
axios.apiOrder = apiOrder
axios.apiPayment = apiPayment
axios.apiCampaign = apiCampaign
axios.apiCoupon = apiCoupon
axios.apiSlotGame = apiSlotGame
axios.apiBanners = apiBanners
axios.apiContent = apiContent
axios.apiTopic = apiTopic
axios.apiLoyalty = apiLoyalty
axios.apiGiftcard = apiGiftcard

export default axios



// WEBPACK FOOTER //
// ./src/axios.js